import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Shield, Plus, ArrowLeft } from 'react-feather';
import { toast } from 'react-toastify';
import config from '../../../../config';

import '../../../ControlPanel/sadmin.css';
import '../../Settings/settings.css';
import '../admin-v3.css';

const on = (v) => v === 1 || v === true || v === '1';

const ManageProfile = ({ embedded = false }) => {
    const { t } = useTranslation();
    const canManage = localStorage.getItem('manageUserProfile') === '1';
    const token = localStorage.getItem('sessiontoken');
    const configheader = { headers: { Authorization: `${token}` } };
    const concessionaire_id = localStorage.getItem('concessionaireId');
    const login_id = localStorage.getItem('loginId');

    const [userProfiles, setUserProfiles] = useState([]);
    const [profileId, setProfileId] = useState('');
    const [viewType, setViewType] = useState(''); // '' | 'Add' | 'Edit'
    const [profileName, setProfileName] = useState('');
    const [saving, setSaving] = useState(false);

    const [accessDashboard, setAccessDashboard] = useState(0);
    const [accessAnalytics, setAccessAnalytics] = useState(0);
    const [accessReports, setAccessReports] = useState(0);
    const [accessDataGrid, setAccessDataGrid] = useState(0);
    const [accessGeneralSettings, setAccessGeneralSettings] = useState(0);
    const [manageGeneralSettings, setManageGeneralSettings] = useState(0);
    const [manageUsers, setManageUsers] = useState(0);
    const [manageUserProfiles, setMnanageUserProfiles] = useState(0);
    const [manageConfig, setMnanageConfig] = useState(0);
    const [accessTenants, setAccessTenants] = useState(0);
    const [manageTenants, setManageTenants] = useState(0);
    const [accessLogs, setAccessLogs] = useState(0);
    const [manageScheduleReports, setMananageScheduleReports] = useState(0);
    const [manualPortalAccess, setManualPortalAccess] = useState(0);
    const [manageLeaseDetails, setManageLeaseDetails] = useState(0);
    const [revenueReports, setRevenueReports] = useState(0);
    const [accessLicenses, setAccessLicenses] = useState(0);
    const [manageLicenses, setManageLicenses] = useState(0);
    const [accessHealthCheckup, setAccessHealthCheckup] = useState(0);

    useEffect(() => {
        if (!embedded && !canManage) {
            window.alert(t('You are not authorized to view this page'));
            window.history.back();
        }
    }, [canManage, embedded]);

    const fetchProfiles = () => {
        axios.post(`${config.hostname}/userpermissions/getpermissionbyconcessionaire`, { concessionaire_id }, configheader)
            .then((res) => setUserProfiles(res.data || []))
            .catch((err) => console.log(err));
    };

    useEffect(() => { fetchProfiles(); }, []);

    const resetFlags = () => {
        setProfileName('');
        [setAccessDashboard, setAccessAnalytics, setAccessReports, setAccessDataGrid, setAccessGeneralSettings,
            setManageGeneralSettings, setManageUsers, setMnanageUserProfiles, setMnanageConfig, setAccessTenants,
            setManageTenants, setAccessLogs, setMananageScheduleReports, setManualPortalAccess, setManageLeaseDetails,
            setRevenueReports, setAccessLicenses, setManageLicenses, setAccessHealthCheckup].forEach((s) => s(0));
    };

    const handleProfileClick = (id) => {
        setViewType('Edit');
        setProfileId(id);
        axios.post(`${config.hostname}/userpermissions/getpermissionbyid`, { id }, configheader)
            .then((res) => {
                const d = res.data;
                setProfileName(d.user_type_id.user_role);
                setAccessDashboard(d.access_dashboard);
                setAccessAnalytics(d.access_analytics);
                setAccessReports(d.access_report);
                setAccessDataGrid(d.access_data_grid);
                setAccessGeneralSettings(d.acess_general_settings);
                setManageGeneralSettings(d.manage_general_settings);
                setManageUsers(d.manage_users);
                setMnanageUserProfiles(d.manage_user_profile);
                setMnanageConfig(d.manage_configurations);
                setAccessTenants(d.access_tenants);
                setManageTenants(d.manage_tenants);
                setAccessLogs(d.access_logs);
                setMananageScheduleReports(d.manage_schedule_reports);
                setManualPortalAccess(d.manual_portal_access);
                setManageLeaseDetails(d.manage_lease_details);
                setRevenueReports(d.revenue_share_reports);
                setAccessLicenses(d.access_licenses || 0);
                setManageLicenses(d.manage_licenses || 0);
                setAccessHealthCheckup(d.access_health_checkup || 0);
            })
            .catch((err) => console.log(err));
    };

    const handleCheckBoxToggle = (type, isChecked) => {
        const v = isChecked ? 1 : 0;
        const map = {
            dashboard: setAccessDashboard, analytics: setAccessAnalytics, reports: setAccessReports,
            datagrid: setAccessDataGrid, accessGeneralSettings: setAccessGeneralSettings,
            manageGeneralSettings: setManageGeneralSettings, manageUsers: setManageUsers,
            manageUserProfiles: setMnanageUserProfiles, manageConfigurations: setMnanageConfig,
            accessTenants: setAccessTenants, manageTenants: setManageTenants, manageLeaseDetails: setManageLeaseDetails,
            accessLogs: setAccessLogs, manageScheduleReports: setMananageScheduleReports,
            manualPortalAccess: setManualPortalAccess, revenueReports: setRevenueReports,
            accessLicenses: setAccessLicenses, manageLicenses: setManageLicenses,
            accessHealthCheckup: setAccessHealthCheckup,
        };
        if (map[type]) map[type](v);
    };

    const buildPayload = () => ({
        user_role: profileName,
        concessionaire_id,
        access_dashboard: accessDashboard,
        access_analytics: accessAnalytics,
        access_report: accessReports,
        access_data_grid: accessDataGrid,
        acess_general_settings: accessGeneralSettings,
        manage_general_settings: manageGeneralSettings,
        manage_configurations: manageConfig,
        access_tenants: accessTenants,
        manage_tenants: manageTenants,
        manage_users: manageUsers,
        manage_user_profile: manageUserProfiles,
        access_logs: accessLogs,
        manage_schedule_reports: manageScheduleReports,
        manual_portal_access: manualPortalAccess,
        manage_lease_details: manageLeaseDetails,
        revenue_share_reports: revenueReports,
        access_licenses: accessLicenses,
        manage_licenses: manageLicenses,
        access_health_checkup: accessHealthCheckup,
        login_id,
    });

    const submit = (e) => {
        e.preventDefault();
        const isEdit = viewType === 'Edit';
        setSaving(true);
        if (isEdit) {
            axios.post(`${config.hostname}/userpermissions/updateuserpermission/${profileId}`, buildPayload(), configheader)
                .then(() => { toast.success(t('Successfully updated')); fetchProfiles(); setViewType(''); resetFlags(); })
                .catch((err) => { toast.error(t('Error')); console.log(err); })
                .finally(() => setSaving(false));
        } else {
            // Reject duplicate profile names first.
            axios.post(`${config.hostname}/userpermissions/checkprofilename`, { concessionaire_id, user_role: profileName }, configheader)
                .then((res) => {
                    if (res.data.exists !== 0) { toast.warning(t('Profile name already exists.')); setSaving(false); return; }
                    axios.post(`${config.hostname}/userpermissions/createuserpermission`, buildPayload(), configheader)
                        .then(() => { toast.success(t('Successfully added')); fetchProfiles(); setViewType(''); resetFlags(); })
                        .catch((err) => { toast.error(t('Error')); console.log(err); })
                        .finally(() => setSaving(false));
                })
                .catch((err) => { console.log(err); setSaving(false); });
        }
    };

    if (!canManage) return null;

    const ACCESS = [
        { t: 'dashboard', l: 'Dashboard', v: accessDashboard },
        { t: 'analytics', l: 'Analytics', v: accessAnalytics },
        { t: 'reports', l: 'Reports', v: accessReports },
        { t: 'datagrid', l: 'Data Grid', v: accessDataGrid },
        { t: 'revenueReports', l: 'Revenue Share Reports', v: revenueReports },
        { t: 'accessGeneralSettings', l: 'General Settings', v: accessGeneralSettings },
        { t: 'accessTenants', l: 'Tenants', v: accessTenants },
        { t: 'accessLogs', l: 'Logs', v: accessLogs },
        { t: 'accessLicenses', l: 'License Inventory', v: accessLicenses },
        { t: 'accessHealthCheckup', l: 'Live Health Checkup', v: accessHealthCheckup },
    ];
    const MANAGE = [
        { t: 'manageGeneralSettings', l: 'General Settings', v: manageGeneralSettings },
        { t: 'manageUsers', l: 'Users', v: manageUsers },
        { t: 'manageUserProfiles', l: 'User Profiles', v: manageUserProfiles },
        { t: 'manageConfigurations', l: 'Configurations', v: manageConfig },
        { t: 'manageTenants', l: 'Tenants', v: manageTenants },
        { t: 'manageScheduleReports', l: 'Schedule Reports', v: manageScheduleReports },
        { t: 'manualPortalAccess', l: 'Tenant Portal Access', v: manualPortalAccess },
        { t: 'manageLeaseDetails', l: 'Lease Details', v: manageLeaseDetails },
        { t: 'manageLicenses', l: 'License Inventory', v: manageLicenses },
    ];

    const toggleRow = (p) => (
        <div className="up-perm-row" key={p.t}>
            <span className="lbl">{t(p.l)}</span>
            <label className="switch">
                <input type="checkbox" checked={on(p.v)} onChange={(e) => handleCheckBoxToggle(p.t, e.target.checked)} />
                <span className="switch-state"></span>
            </label>
        </div>
    );

    const renderForm = (isEdit) => (
        <form className="v3-card" style={{ padding: 22 }} onSubmit={submit}>
            <div className="v3-field" style={{ maxWidth: 420, marginBottom: 18 }}>
                <label>{t('Profile Name')}</label>
                <input className="form-control" type="text" placeholder={t('Profile name')} value={profileName}
                    onChange={(e) => setProfileName(e.target.value)} required />
            </div>
            <div className="up-perm-grid">
                <div className="up-perm-col">
                    <h4>{t('Access')}</h4>
                    {ACCESS.map(toggleRow)}
                </div>
                <div className="up-perm-col">
                    <h4>{t('Manage')}</h4>
                    {MANAGE.map(toggleRow)}
                </div>
            </div>
            <div className="up-save-bar">
                <button type="submit" className="v3-btn v3-btn-primary" disabled={saving}>
                    {saving ? t('Saving…') : isEdit ? t('Update profile') : t('Create profile')}
                </button>
            </div>
        </form>
    );

    const actions = viewType === '' ? (
        <button type="button" className="v3-btn v3-btn-primary" onClick={() => { resetFlags(); setViewType('Add'); }}>
            <Plus size={15} /> {t('Add New')}
        </button>
    ) : (
        <button type="button" className="v3-btn v3-btn-ghost" onClick={() => { setViewType(''); resetFlags(); }}>
            <ArrowLeft size={15} /> {t('Back')}
        </button>
    );

    const body = (
        <>
            {viewType === '' && (
                <div className="v3-card v3-sadmin-list-card">
                    <div className="v3-sadmin-list-header">
                        <div className="v3-sadmin-list-title">
                            <h2 className="v3-title">{t('Profiles')}</h2>
                            <span className="v3-sadmin-list-count">{userProfiles.length}</span>
                        </div>
                    </div>
                    {userProfiles.length === 0 ? (
                        <div className="v3-sadmin-empty"><h3>{t('No profiles yet')}</h3><p>{t('Add a profile to define role permissions.')}</p></div>
                    ) : (
                        <div className="v3-sadmin-table-wrap">
                            <table className="table" style={{ margin: 0 }}>
                                <thead><tr><th>#</th><th>{t('Profile Name')}</th></tr></thead>
                                <tbody>
                                    {userProfiles.map((item, index) => (
                                        <tr key={item._id || index} onClick={() => handleProfileClick(item._id)} style={{ cursor: 'pointer' }}>
                                            <td>{index + 1}</td>
                                            <td>{item.user_type_id ? item.user_type_id.user_role : ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
            {viewType === 'Add' && renderForm(false)}
            {viewType === 'Edit' && renderForm(true)}
        </>
    );

    // Embedded in the Users & Roles host: no own shell/hero, actions in a sub-toolbar.
    if (embedded) {
        return (
            <Fragment>
                <div className="v3-um-subbar">{actions}</div>
                {body}
            </Fragment>
        );
    }

    return (
        <div className="v3-sadmin v3-admin-page">
            <div className="v3-sadmin-hero">
                <div className="v3-sadmin-hero-text">
                    <p className="v3-label" style={{ margin: 0 }}>{t('Admin settings')}</p>
                    <h1 className="v3-display v3-sadmin-greeting">
                        <span className="v3-sadmin-name">
                            {viewType === 'Add' ? t('Add Profile') : viewType === 'Edit' ? t('Edit Profile') : t('User Profiles')}
                        </span>
                    </h1>
                    <p className="v3-body v3-sadmin-sub">{t('Define role permissions — what each profile can access and manage.')}</p>
                </div>
                <div className="v3-sadmin-hero-actions">
                    {actions}
                    <span className="v3-sadmin-kpi-icon accent" aria-hidden><Shield size={18} /></span>
                </div>
            </div>
            {body}
        </div>
    );
};

export default ManageProfile;
